// extracted by mini-css-extract-plugin
export default {"turntable":"style_turntable__cy6za"};